import DataCacheRepository from '../../../analytics/src/datalayer/data-cache-repository';
window.tp = window.tp || [];

tp.push( [ 'init', function () {
	function getSignInServicePlatform () {
		return tp?.pianoId?.getUser()?.ls === 'GOOGLE' ? 'google' : 'native';
	}

	function dispatchNativeSignInEvent ( signInStatus, partyId = null ) {
		DataCacheRepository.setItem(
			getSignInServicePlatform(),
			DataCacheRepository.KEY_NS_ACCOUNT_SIGN_IN,
			DataCacheRepository.TTL_SIGN_IN,
		);
		window.dispatchEvent(
			new CustomEvent( 'nsAccountSignIn', {
				detail: {
					signInStatus,
					partyId,
				},
			} ),
		);
	}

	tp.pianoId.show( {
		displayMode: 'inline',
		screen: 'login',
		containerSelector: '#login-form',
		loginFailed ( data ) {
			dispatchNativeSignInEvent( data?.errors?.[ 0 ]?.message || 'failed' );
		},
	    loginSuccess ( data ) {
			dispatchNativeSignInEvent( 'success', data?.user?.uid || null );
		},
		loggedOut () {
			//For future use
		},
	} );
} ] );
